import { IconProps } from "./Icons";

export const IconHome = ({
  width = 37,
  height = 37,
  isHovered = false,
}: IconProps) => {
  if (isHovered) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 38 32"
        fill="none"
      >
        <path
          d="M36.4146 29.0434H33.9146V17.7934L34.2802 18.159C34.5151 18.3935 34.8337 18.5252 35.1657 18.5249C35.4977 18.5246 35.8159 18.3924 36.0505 18.1574C36.285 17.9225 36.4166 17.604 36.4164 17.272C36.4161 16.94 36.2839 16.6217 36.0489 16.3871L20.6817 1.02462C20.2129 0.556136 19.5773 0.292969 18.9146 0.292969C18.2518 0.292969 17.6162 0.556136 17.1474 1.02462L1.78018 16.3871C1.54583 16.6217 1.41426 16.9397 1.41441 17.2713C1.41455 17.6028 1.54641 17.9207 1.78096 18.1551C2.01551 18.3894 2.33354 18.521 2.6651 18.5209C2.99666 18.5207 3.31458 18.3889 3.54893 18.1543L3.91455 17.7934V29.0434H1.41455C1.08303 29.0434 0.765088 29.1751 0.530667 29.4095C0.296247 29.6439 0.164551 29.9619 0.164551 30.2934C0.164551 30.6249 0.296247 30.9428 0.530667 31.1773C0.765088 31.4117 1.08303 31.5434 1.41455 31.5434H36.4146C36.7461 31.5434 37.064 31.4117 37.2984 31.1773C37.5329 30.9428 37.6646 30.6249 37.6646 30.2934C37.6646 29.9619 37.5329 29.6439 37.2984 29.4095C37.064 29.1751 36.7461 29.0434 36.4146 29.0434ZM6.41455 15.2934L18.9146 2.79337L31.4146 15.2934V29.0434H23.9146V20.2934C23.9146 19.9619 23.7829 19.6439 23.5484 19.4095C23.314 19.1751 22.9961 19.0434 22.6646 19.0434H15.1646C14.833 19.0434 14.5151 19.1751 14.2807 19.4095C14.0462 19.6439 13.9146 19.9619 13.9146 20.2934V29.0434H6.41455V15.2934ZM21.4146 29.0434H16.4146V21.5434H21.4146V29.0434Z"
          fill="#FFFDFD"
        />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M27.3538 12.9713L17.3538 3.53626C17.3489 3.532 17.3443 3.5274 17.34 3.52251C16.9718 3.18768 16.492 3.00214 15.9944 3.00214C15.4967 3.00214 15.0169 3.18768 14.6488 3.52251L14.635 3.53626L4.64625 12.9713C4.4425 13.1586 4.27985 13.3862 4.16861 13.6397C4.05737 13.8932 3.99996 14.167 4 14.4438V26C4 26.5304 4.21071 27.0392 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H12C12.5304 28 13.0391 27.7893 13.4142 27.4142C13.7893 27.0392 14 26.5304 14 26V20H18V26C18 26.5304 18.2107 27.0392 18.5858 27.4142C18.9609 27.7893 19.4696 28 20 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0392 28 26.5304 28 26V14.4438C28 14.167 27.9426 13.8932 27.8314 13.6397C27.7201 13.3862 27.5575 13.1586 27.3538 12.9713ZM26 26H20V20C20 19.4696 19.7893 18.9609 19.4142 18.5858C19.0391 18.2107 18.5304 18 18 18H14C13.4696 18 12.9609 18.2107 12.5858 18.5858C12.2107 18.9609 12 19.4696 12 20V26H6V14.4438L6.01375 14.4313L16 5.00001L25.9875 14.4288L26.0012 14.4413L26 26Z"
          fill="white"
        />
      </svg>
    );
  }
};
